import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as i, openBlock as d, normalizeClass as n, createElementVNode as l } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconToken",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ l("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.251.701a1.5 1.5 0 0 1 1.498 0h.001l3.5 2A1.5 1.5 0 0 1 11 4v4a1.503 1.503 0 0 1-.75 1.299l-.002.001-3.498 1.999h-.001a1.5 1.5 0 0 1-1.498 0H5.25l-3.498-2-.002-.001A1.5 1.5 0 0 1 1 8V4a1.502 1.502 0 0 1 .75-1.298l.002-.001 3.5-2Zm.749.8a.5.5 0 0 0-.25.067l-.002.001L2.25 3.568A.503.503 0 0 0 2 4v4a.5.5 0 0 0 .25.431s-.001 0 0 0l3.5 2a.5.5 0 0 0 .5 0h.002l3.498-2s0 .001 0 0A.503.503 0 0 0 10 8V4a.5.5 0 0 0-.25-.432c.001 0 0 0 0 0l-3.5-2A.5.5 0 0 0 6 1.501Z",
  fill: "currentColor"
}, null, -1), u = /* @__PURE__ */ l("path", {
  d: "M7 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
  fill: "currentColor"
}, null, -1), m = [
  _,
  u
];
function h(e, f, r, p, v, a) {
  return d(), i("svg", {
    "aria-label": r.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--token"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Token",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, m, 10, c);
}
const k = /* @__PURE__ */ o(s, [["render", h]]);
export {
  k as default
};
//# sourceMappingURL=token.js.map
